import { render, staticRenderFns } from "./TestEdit.vue?vue&type=template&id=5ab00edd&scoped=true&"
import script from "./TestEdit.vue?vue&type=script&lang=js&"
export * from "./TestEdit.vue?vue&type=script&lang=js&"
import style0 from "./TestEdit.vue?vue&type=style&index=0&id=5ab00edd&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab00edd",
  null
  
)

export default component.exports